module.exports = __webpack_public_path__ + "img/game_glive.97e3ef7.jpg";